import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Linkedin, Phone, Mail, MapPin } from 'lucide-react';
import { footerLinks, quickLinks } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import YppsdpLogo from '../YppsdpLogo';

const socialIcons = { Facebook, Twitter, Instagram, Youtube, Linkedin };

const Footer = () => {
  const { lang } = useLang();
  const qLinks = quickLinks[lang];
  const fLinks = footerLinks[lang];

  return (
    <footer className="bg-[#0a1929] text-white/85 mt-16">
      <div className="h-1 bg-gradient-to-r from-[#b8860b] via-[#d4a017] to-[#b8860b]" />
      <div className="bg-[#0f2340] py-5 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-sm">
            {qLinks.map((q, i) => (
              <React.Fragment key={q}>
                <a href="#" className="hover:text-[#d4a017] transition">{q}</a>
                {i < qLinks.length - 1 && <span className="text-white/20">|</span>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <YppsdpLogo size={52} className="drop-shadow-lg" />
            <div className="leading-tight">
              <div className="text-[10px] tracking-[0.18em] text-[#d4a017] font-bold">YAYASAN</div>
              <div className="text-lg font-bold" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>PPSDP</div>
              <div className="text-[10px] tracking-wider text-white/60">Pengembangan Potensi Sumber Daya Pertahanan</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-white/70 mb-4">
            {lang === 'id'
              ? 'Yayasan Pengembangan Potensi Sumber Daya Pertahanan yang mengelola pendidikan tinggi, program perumahan sosial purnawirawan, dan unit usaha strategis demi kemandirian bangsa.'
              : 'Foundation for Development of Defense Resource Potential managing higher education, retiree social housing programs, and strategic business units for national self-reliance.'}
          </p>
          <div className="space-y-2 text-sm text-white/70">
            <div className="flex items-start gap-2"><MapPin size={16} className="text-[#d4a017] mt-0.5 flex-shrink-0" /> Kantor Pusat YPPSDP, Jakarta, Indonesia</div>
            <div className="flex items-center gap-2"><Phone size={16} className="text-[#d4a017] flex-shrink-0" /> (021) 000-0000</div>
            <div className="flex items-center gap-2"><Mail size={16} className="text-[#d4a017] flex-shrink-0" /> humas@yppsdp.id</div>
          </div>
        </div>

        {Object.entries(fLinks).map(([title, links]) => (
          <div key={title}>
            <h4 className="text-[#d4a017] font-bold uppercase tracking-wider text-xs mb-4 pb-2 border-b border-white/10">{title}</h4>
            <ul className="space-y-2">
              {links.map((l) => (
                <li key={l}><Link to="/tentang" className="text-sm text-white/70 hover:text-white hover:translate-x-1 inline-block transition">{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            {Object.entries(socialIcons).map(([n, Icon]) => (
              <a key={n} href="#" className="w-9 h-9 grid place-items-center rounded border border-white/20 hover:border-[#d4a017] hover:bg-[#d4a017] hover:text-[#0a1929] transition">
                <Icon size={16} />
              </a>
            ))}
          </div>
          <div className="text-xs text-white/50 text-center md:text-right">
            <div>&copy; 2025 YPPSDP. {lang === 'id' ? 'Situs demo replika bergaya navy.mil.' : 'Demo site with navy.mil style.'}</div>
            <div className="mt-1">{lang === 'id' ? 'Privasi • Aksesibilitas • Peta Situs • Kontak' : 'Privacy • Accessibility • Sitemap • Contact'}</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
